module.exports = __webpack_public_path__ + "media/images/country_flags/pn-f991d49e29df8a728f923ad5afb3e322.png";